import * as z from "zod/v4";

const BillingCharge_ = z.object({
  description: z.string(),
  amount: z.number(),
  reason: z.string().nullable(),
});

export const BillingCharge: z.ZodType<BillingCharge> = BillingCharge_;
export interface BillingCharge extends z.infer<typeof BillingCharge_> {}

const GetSubscriptionFeeBillingPreviewInput_ = z.object({
  teamId: z.string(),
  overrides: z
    .object({
      omsTurnedOnAt: z.string().nullish(),
      omsAmount: z.number().nullish(),
      wmsTurnedOnAt: z.string().nullish(),
      wmsAmount: z.number().nullish(),
    })
    .nullish(),
});

export const GetSubscriptionFeeBillingPreviewInput: z.ZodType<GetSubscriptionFeeBillingPreviewInput> =
  GetSubscriptionFeeBillingPreviewInput_;
export interface GetSubscriptionFeeBillingPreviewInput
  extends z.infer<typeof GetSubscriptionFeeBillingPreviewInput_> {}

export const getSubscriptionFeeBillingPreview = {
  name: "getSubscriptionFeeBillingPreview" as const,
  input: GetSubscriptionFeeBillingPreviewInput,
  output: z.object({
    nextBillingDate: z.string(),
    omsCharges: z.array(BillingCharge),
    wmsCharges: z.array(BillingCharge),
    labelFeeCharges: z.array(BillingCharge),
    totalAmount: z.number(),
    noChargesReason: z.string().nullable(),
    hasShipped: z.boolean(),
  }),
};
